module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921134149_T.f640fea0.jpg";